import { Component, OnChanges, ViewChild, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.sass']
})
export class ProfileComponent implements OnChanges {

  @ViewChild('leftarrow', {read: ElementRef}) leftarrow
  @ViewChild('rightarrow', {read: ElementRef}) rightarrow
  @ViewChild('post', {read: ElementRef}) post
  @ViewChild('message', {read: ElementRef}) message
  @ViewChild('receipt', {read: ElementRef}) receipt
  @ViewChild('EA', {read: ElementRef}) EA
  @ViewChild('PA', {read: ElementRef}) PA
  profileJson = {};
  userProf: any;
  totalPostsPages: number;
  totalMessagesPages: number;
  edittedPost: {}
  @Input() currentMessagePage: number;
  @Input() totalM: number;
  @Input() totalP: number;

  @Input() currentPostPage: number;
  @Input() changing: boolean;

  @Output() pageTurnerRight = new EventEmitter()
  @Output() pageTurnerLeft = new EventEmitter()
  @Output() reloadMainPostData = new EventEmitter();


  category = 'message'
  add = false
  edit = false
  userPosts: object[]
  userMessages: object[]
  totalPosts: number
  totalMessages: number
  prevPost: boolean
  nextPost: boolean
  prevMessage: boolean
  nextMessage: boolean
  messageSubmitted = ''
  postSubmitted = ''
  constructor(public auth: AuthService, private renderer: Renderer2, private apiService: ApiService) { }

  ngOnChanges() {
    this.auth.user$.subscribe(
      profile => {
        this.profileJson = profile
        this.apiService.getUserPosts(profile['sub'].substring(18), this.currentPostPage).subscribe(data => {
          this.postSubmitted = 'loading'
          if (data.count > 0 && this.totalM !== -1) {
            this.userPosts = data.results;
            this.postSubmitted = ''

          }
          else {
            this.userPosts = [{"item": "You Have No Posts"}]
            this.postSubmitted = ''

          }
          this.totalPosts = data.count;
          this.totalPostsPages = Math.ceil(data.count/16)
          if (data.links['next'] === null) {
            this.nextPost = false
          }
          else {
            this.nextPost = true
          }
          if (data.links['previous'] === null) {
            this.prevPost = false
          }
          else {
            this.prevPost = true
          }
        },
          (error)=> {console.log("error", error)})
        
          this.apiService.getUserMessages(profile['sub'].substring(18), this.currentMessagePage).subscribe(data => {
            this.messageSubmitted = 'loading'
            if (data.count > 0 && this.totalM !== -1) {
              this.userMessages = data.results;
              this.messageSubmitted = ''              
            }
            else {
              this.userMessages = [{"title": "You Have No Messages"}]
              this.messageSubmitted = ''
            }
            this.totalMessages = data.count;
            this.totalMessagesPages = Math.ceil(data.count/16)
            if (data.links['next'] === null) {
              this.nextMessage = false
            }
            else {
              this.nextMessage = true
            }
            if (data.links['previous'] === null) {
              this.prevMessage = false
            }
            else {
              this.prevMessage = true
            }
          },
            (error)=> {console.log("error", error)})
      }
    );
  }

  pageTurnLeft(val1,val2,val3, val4, val5, val6, val7) {
    this.pageTurnerLeft.emit([val1, val2, val3, val4, val5, val6, val7])
  }

  pageTurnRight(val1,val2,val3, val4, val5, val6, val7) {
    this.pageTurnerRight.emit([val1, val2, val3, val4, val5, val6, val7])
  }

  categorySelect(cat: string): void {

    this.category = cat
    this.message.nativeElement.classList.remove('selectedH2')
    this.post.nativeElement.classList.remove('selectedH2')
    this.PA.nativeElement.classList.remove('selectedH2')

    if (cat === "message") {
      this.message.nativeElement.classList.add('selectedH2')
      this.add = false
      this.edit = false
    }

    else if (cat === "post") {
      this.post.nativeElement.classList.add('selectedH2')
      this.add = false
      this.edit = false
    }

    else {
      this.PA.nativeElement.classList.add('selectedH2')
      this.add = true
      this.edit = false
    }
  }

  editPost (edittingPost) {
    this.edit = true
    this.add = false

    this.category = 'EA'
    this.edittedPost = edittingPost
    this.post.nativeElement.classList.remove('selectedH2')
  }

  // childX(val) {
  //   this.parentX.emit(val)
  // }

  reloadPostData(val0, val) {
    if (val0 === "add") {
      this.reloadMainPostData.emit(val+1)
    }
    else if (val0 === "delete"){
      this.reloadMainPostData.emit(val-1)
    }
    else {
      this.reloadMainPostData.emit(JSON.stringify(this.userPosts))
    }
    // WRITE ANOTHER ELSE STATEMENT FOR edit values

    this.apiService.getUserPosts(this.profileJson['sub'].substring(18), this.currentPostPage).subscribe(data => {
      if (data.count > 0 && this.totalM !== -1) {
        this.userPosts = data.results;
      }
      else {
        this.userPosts = [{"item": "You Have No Posts"}]
      }
      this.totalPosts = data.count;
      this.totalPostsPages = Math.ceil(data.count/16)
      if (data.links['next'] === null) {
        this.nextPost = false
      }
      else {
        this.nextPost = true
      }
      if (data.links['previous'] === null) {
        this.prevPost = false
      }
      else {
        this.prevPost = true
      }
    },
      (error)=> {console.log("error", error)})
  }

  reloadMessageData(val) {
    this.apiService.getUserMessages(this.profileJson['sub'].substring(18), this.currentMessagePage).subscribe(data => {
      if (data.count > 0 && this.totalM !== -1) {
        this.userMessages = data.results;
      }
      else {
        this.userMessages = [{"title": "You Have No Messages"}]
      }
      this.totalMessages = data.count;
      this.totalMessagesPages = Math.ceil(data.count/16)
      if (data.links['next'] === null) {
        this.nextMessage = false
      }
      else {
        this.nextMessage = true
      }
      if (data.links['previous'] === null) {
        this.prevMessage = false
      }
      else {
        this.prevMessage = true
      }
    },
      (error)=> {console.log("error", error)})
  }

}
